import { render, staticRenderFns } from "./ObjectDetailsOrders.vue?vue&type=template&id=732d6027&"
import script from "./ObjectDetailsOrders.vue?vue&type=script&lang=js&"
export * from "./ObjectDetailsOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports